import { useEffect, useState } from "react";
import { endImpersonation, readImpersonatorBackup, readLocalSession } from "../localSession";

/**
 * The persistent "Viewing as…" bar shown while a SysAdmin is impersonating another user ("Load site
 * as…"). It reads the parked admin session straight from sessionStorage, so it is **independent of
 * the impersonated user's role** — a SysAdmin viewing as a non-SysAdmin keeps this Exit even though
 * the burger's "Load site as…" is gone for them. Exit restores the admin session and reloads.
 *
 * Rendered globally (main.tsx) alongside DevBanner; returns null when no impersonation is in progress.
 */
export function ImpersonationBanner() {
  const [backup] = useState(() => readImpersonatorBackup());

  useEffect(() => {
    if (!backup) return;
    document.body.classList.add("has-impersonation-banner");
    return () => { document.body.classList.remove("has-impersonation-banner"); };
  }, [backup]);

  if (!backup) return null;
  const viewingAs = readLocalSession()?.displayName ?? "another user";
  const exit = () => { endImpersonation(); window.location.reload(); };

  return (
    <div className="impersonation-banner" role="status">
      <span>Viewing the site as <strong>{viewingAs}</strong></span>
      <button type="button" onClick={exit}>Exit</button>
    </div>
  );
}
